export default {"src":"/_next/static/media/cover-ServicesSP.5b881e02.svg","height":847,"width":1192};